import { inject } from '@angular/core';
import { HttpRequest, HttpEvent, HttpEventType, HttpHandlerFn } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { RestApiService } from '../services/rest-api-service/rest-api-service';

export function HttpInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const restApiService = inject(RestApiService);
  const isRefreshToken = request.url.includes('refresh-token');

  const headers = restApiService.createAuthorizationHeader(isRefreshToken);

  const req = request.clone({
    setHeaders: headers.keys().reduce(
      (acc, key) => {
        acc[key] = headers.get(key)!;
        return acc;
      },
      {} as Record<string, string>
    ),
  });
  return next(req);
}
